export default function convertPriceByCurrency(price) {
    let result = (price / currency.rate) * currency.coefficient;
    result = result % 1 == 0 ? result.toFixed(0) : result.toFixed(2); 

    return result.replace('.', ',');
}